import { render } from "./TerminalSetup.vue?vue&type=template&id=55f73d15&scoped=true"
import script from "./TerminalSetup.vue?vue&type=script&lang=js"
export * from "./TerminalSetup.vue?vue&type=script&lang=js"

import "./TerminalSetup.vue?vue&type=style&index=0&id=55f73d15&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f73d15"]])

export default __exports__